import React from 'react';
import '../styles/Unauthorized.css';
import { UNAUTHORIZED_MESSAGES } from '../constants';

const Unauthorized = ({ errorMessage }) => {
    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <div className="unauth-wrapper">
            {!errorMessage ? (
                <>
                    <h1>{UNAUTHORIZED_MESSAGES.DEFAULT_TITLE}</h1>
                    <p>{UNAUTHORIZED_MESSAGES.DEFAULT_DESCRIPTION}</p>
                </>
            ) : (
                <>
                    <div className="error-message">{errorMessage}</div>
                    <button className="refresh-button" onClick={handleRefresh}>
                        {UNAUTHORIZED_MESSAGES.REFRESH_BUTTON}
                    </button>
                </>
            )}
        </div>
    );
};

export default Unauthorized;